module.exports = __webpack_public_path__ + "static/media/gender-women.76c9f8f7.svg";